if (!customElements.get('bd-tin-upsell')) {
  class BDTinUpsell extends HTMLElement {
    static busy = false;

    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('[data-tin-add]');
      this.status = this.querySelector('[role="status"]');
      this.button.addEventListener('click', () => this.addTin());
    }

    async request(path, data) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + path, {
        method: data ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(data ? { body: JSON.stringify(data) } : { cache: 'no-store' })
      });
      const result = await response.json();
      if (!response.ok) throw new Error('Cart request failed');
      return result;
    }

    discountCodes(cart) {
      const codes = (cart.discount_codes || []).map(discount => discount.code);
      for (const application of cart.cart_level_discount_applications || []) {
        if (application.type === 'discount_code') codes.push(application.title);
      }
      for (const item of cart.items || []) {
        for (const allocation of item.line_level_discount_allocations || []) {
          const application = allocation.discount_application;
          if (application?.type === 'discount_code') codes.push(application.title);
        }
      }
      return [...new Set(codes.filter(Boolean))];
    }

    async addTin() {
      if (BDTinUpsell.busy) return;
      BDTinUpsell.busy = true;
      const originalLabel = this.button.innerHTML;
      this.button.disabled = true;
      this.button.textContent = this.dataset.adding;
      this.status.textContent = '';
      const checkoutControls = [...document.querySelectorAll('button[name="checkout"], input[name="checkout"]')].map(element => ({ element, disabled: element.disabled }));
      const expressControls = [...document.querySelectorAll('.additional-checkout-buttons')].map(element => ({ element, inert: element.inert }));
      checkoutControls.forEach(({ element }) => { element.disabled = true; });
      expressControls.forEach(({ element }) => { element.inert = true; });
      const variantId = Number(this.dataset.variantId);
      let before;
      let addStarted = false;
      let discountStarted = false;
      let originalCodes = [];
      try {
        before = await this.request('cart.js');
        if (before.currency !== 'GBP' || !before.items.some(item => item.variant_id !== variantId && item.final_line_price > 0)) throw new Error('Cart is not eligible');
        if (before.items.some(item => item.variant_id === variantId)) {
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        const product = await this.request('products/' + this.dataset.productHandle + '.js');
        const variant = product.variants.find(item => item.id === variantId);
        if (!variant?.available || variant.price !== 2499) throw new Error('Offer unavailable');
        originalCodes = this.discountCodes(before);
        addStarted = true;
        await this.request('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _bd_tin_upsell: 'v1' } }] });
        discountStarted = true;
        const codes = [...new Set([...originalCodes, this.dataset.discountCode])];
        const after = await this.request('cart/update.js', { discount: codes.join(',') });
        const tin = after.items.find(item => item.variant_id === variantId && item.properties?._bd_tin_upsell === 'v1');
        if (!tin || tin.quantity !== 1 || tin.final_line_price !== 2000) throw new Error('Tin discount was not applied');
        const others = after.items.filter(item => item.variant_id !== variantId);
        const previousTotal = before.items.reduce((sum, item) => sum + item.final_line_price, 0);
        const nextTotal = others.reduce((sum, item) => sum + item.final_line_price, 0);
        if (nextTotal > previousTotal || after.total_price > before.total_price + 2000) throw new Error('Existing discount could not be preserved');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        let restored = true;
        if (addStarted) {
          try {
            const current = await this.request('cart.js');
            const added = current.items.find(item => item.variant_id === variantId && item.properties?._bd_tin_upsell === 'v1');
            if (added) await this.request('cart/change.js', { id: added.key, quantity: 0 });
            if (discountStarted) await this.request('cart/update.js', { discount: originalCodes.join(',') });
          } catch (rollbackError) {
            restored = false;
          }
        }
        this.status.textContent = restored ? this.dataset.error : this.dataset.checkCart;
        this.button.disabled = false;
        this.button.innerHTML = originalLabel;
      } finally {
        checkoutControls.forEach(({ element, disabled }) => { element.disabled = disabled; });
        expressControls.forEach(({ element, inert }) => { element.inert = inert; });
        BDTinUpsell.busy = false;
      }
    }
  }
  customElements.define('bd-tin-upsell', BDTinUpsell);
}
